import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import TriangulationChartPageUI from './TriangulationChartPageUI.js'

class TriangulationChartPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataKeys: {
        revenue: 'revenue',
        expense: 'expense',
        sales: 'sales',
        purchase: 'purchase',
        netProfit: 'netProfit',
        gstNetProfit: 'gstNetProfit',
        cashProfit: 'cashProfit',
        bankSalary: 'bankSalary',
        bankEmi: 'bankEmi',
        bankFinanceCost: 'bankFinanceCost',
        bankCharges: 'bankCharges',
        bankOtherExpense: 'bankOtherExpense',
        bankNetExpense: 'bankNetExpense',
        gstNetExpense: 'gstNetExpense',
        //
        bankRevenue: 'bankRevenue',
        bankExpense: 'bankExpense',
        gstSales: 'gstSales',
        gstPurchase: 'gstPurchase',
        //
        payables: 'payables',
        receivables: 'receivables',
        advancesPaid: 'advancesPaid',
        advancesReceived: 'advancesReceived'
      },

      accountYearList: null,
      lastMonths: 12,
      lastMonthsList: [],
      //
      showGpVNp: false,
      showExpensesChart: false,
      showRevenue: false,
      showExpense: false
    }
  }

  render() {
    let lastMonthsList = [
      { value: '3', label: 'Last 3 months' },
      { value: '6', label: 'Last 6 months' },
      { value: '12', label: 'Last 12 months' },
    ]
    const { dataKeys } = this.state
    return (
      <TriangulationChartPageUI
        context={this.props.context}
        account={this.state.account}
        onRefreshClick={this.onRefreshClick}
        //
        accountYearList={this.state.accountYearList}
        chartYearlyData={this.state.chartYearlyData}
        lastMonthsChartData={this.state.lastMonthsChartData}
        chartFromAprilData={this.state.chartFromAprilData}
        quaterlyData={this.state.quaterlyData}
        //
        lastMonths={this.state.lastMonths}
        onLastMonthsChange={this.onLastMonthsChange}
        lastMonthsList={lastMonthsList}
        //
        financialYear={this.state.financialYear}
        onFinancialYearChange={this.onFinancialYearChange}
        financialYearList={this.state.financialYearList}
        //
        showGpVNp={this.state.showGpVNp}
        onShowGpVNp={() => { this.setState({ showGpVNp: !this.state.showGpVNp }) }}
        //
        showExpensesChart={this.state.showExpensesChart}
        onShowExpensesChart={() => { this.setState({ showExpensesChart: !this.state.showExpensesChart }) }}
        //
        selectLine={this.handleMouseEnter}
        dataKeys={dataKeys}
      />
    )
  }

  handleMouseEnter = (o) => {
    const { dataKey } = o
    const { dataKeys } = this.state
    if (dataKeys[dataKey] === dataKey) {
      this.setState({
        dataKeys: { ...dataKeys, [dataKey]: dataKeys[dataKey] + ' ' }
      })
    }
    else {
      this.setState({
        dataKeys: { ...dataKeys, [dataKey.trim()]: dataKeys[dataKey.trim()].trim() }
      })
    }
  }

  onLastMonthsChange = (option) => {
    this.setState({ lastMonths: option.value, financialYear: null }, () => {
      this.getTriangulations(this.props.context)
    })
  }

  onFinancialYearChange = (option) => {
    this.setState({ financialYear: option.value }, () => {
      this.getTriangulations(this.props.context)
    })
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getTriangulations(context)
    this.getTriangulationFromApril(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getTriangulations(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/cash/gst-bank/monthly`,
      cacheKey: CacheKeys.Triangulations(this.props.match.params.accountId),
      callback: this.getTriangulationsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getTriangulationsCallback = (response) => {
    let financialYearList = response.accountYearList.map((year) => {
      return {
        value: year.financialYear, label: year.financialYear
      }
    })

    let chartYearlyData = response.accountYearList.map((acc) => {
      return {
        financialYear: acc.financialYear,
        revenue: acc.totalBankCollection / 100,
        expense: Math.abs(acc.totalBankPayment / 100),
        sales: acc.totalGstCollection / 100,
        purchase: acc.totalGstPayment / 100,
        netProfit: acc.totalBankProfitLossNet / 100
      }
    })
    let newChartYearlyData = chartYearlyData.slice(1, chartYearlyData.length + 1)

    let chartMonthlyData

    if (this.state.financialYear) {
      chartMonthlyData = response.accountYearList.filter(year => year.financialYear === this.state.financialYear).map((year) =>
        year.accountMonthList.filter(t => t.gstCollection !== null).map((month) => {
          return {
            yearMonth: month.yearMonth,
            revenue: month.bankCollection / 100,
            expense: Math.abs(month.bankPayment / 100),
            sales: month.gstCollection / 100,
            purchase: month.gstPayment / 100,
            netProfit: month.bankProfitLossNet / 100,
            gstNetProfit: month.gstProfitLossNet / 100,
            cashProfit: month.bankProfitLoss / 100,
            bankSalary: Math.abs(month.bankSalary / 100),
            bankEmi: Math.abs(month.bankEmi / 100),
            bankFinanceCost: Math.abs(month.bankFinanceCost / 100),
            bankCharges: Math.abs(month.bankCharges / 100),
            bankOtherExpense: Math.abs(month.bankOtherExpense / 100),
            bankNetExpense: month.bankNetExpense / 100,
            gstNetExpense: month.gstNetExpense / 100,
            //
            bankRevenue: month.bankCollection / 100,
            bankExpense: Math.abs(month.bankPayment / 100),
            gstSales: month.gstCollection / 100,
            gstPurchase: month.gstPayment / 100,
          }
        })
      )
    }
    else {
      chartMonthlyData = response.accountYearList.map((year) =>
        year.accountMonthList.filter(t => t.gstCollection !== null).map((month) => {
          return {
            yearMonth: month.yearMonth,
            revenue: month.bankCollection / 100,
            expense: Math.abs(month.bankPayment / 100),
            sales: month.gstCollection / 100,
            purchase: month.gstPayment / 100,
            netProfit: month.bankProfitLossNet / 100,
            gstNetProfit: month.gstProfitLossNet / 100,
            cashProfit: month.bankProfitLoss / 100,
            bankSalary: Math.abs(month.bankSalary / 100),
            bankEmi: Math.abs(month.bankEmi / 100),
            bankFinanceCost: Math.abs(month.bankFinanceCost / 100),
            bankCharges: Math.abs(month.bankCharges / 100),
            bankOtherExpense: Math.abs(month.bankOtherExpense / 100),
            bankNetExpense: month.bankNetExpense / 100,
            gstNetExpense: month.gstNetExpense / 100,
            //
            bankRevenue: month.bankCollection / 100,
            bankExpense: Math.abs(month.bankPayment / 100),
            gstSales: month.gstCollection / 100,
            gstPurchase: month.gstPayment / 100,
          }
        })
      )
    }

    let i = 0
    let mergedChartMonthlyData = []
    while (i < [...chartMonthlyData].length) {
      mergedChartMonthlyData = mergedChartMonthlyData.concat(chartMonthlyData[i])
      i++
    }

    let lastMonths = this.state.lastMonths
    let lastMonthsChartData = mergedChartMonthlyData.slice(-lastMonths, mergedChartMonthlyData.length + 1)
    let yearMonthChartData = mergedChartMonthlyData.slice(-12, mergedChartMonthlyData.length + 1)

    let quaterlyData = []
    yearMonthChartData.forEach((item) => {
      if (!quaterlyData.length || quaterlyData[quaterlyData.length - 1].length == 3)
        quaterlyData.push([])
      quaterlyData[quaterlyData.length - 1].push(item)
    })

    this.setState({
      accountYearList: response.accountYearList,
      chartYearlyData: newChartYearlyData,
      lastMonthsChartData: lastMonthsChartData,
      quaterlyData: quaterlyData,
      financialYearList: financialYearList
    })
  }

  getTriangulationFromApril(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/cash/gst-bank/lastNMonths`,
      cacheKey: CacheKeys.TriangulationNMonths(this.props.match.params.accountId, ''),
      callback: this.getTriangulationFromAprilCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context, null, {
      months: ''
    })
  }

  getTriangulationFromAprilCallback = (response) => {
    let p = 0
    let ap = 0
    let r = 0
    let ar = 0
    let payables = response.auditedPayables / 100
    let receivables = response.auditedReceivables / 100

    let chartFromAprilData = response.accountMonthList.map((month) => {
      payables = payables + (month.gstPayment / 100) + (month.bankPayment / 100)
      receivables = receivables + (month.gstCollection / 100) - (month.bankCollection / 100)
      if (payables < 0)
        ap = payables
      else
        p = payables
      if (receivables < 0)
        ar = receivables
      else
        r = receivables

      return {
        yearMonth: month.yearMonth,
        payables: p,
        receivables: r,
        advancesPaid: ap,
        advancesReceived: ar
      }
    })
    this.setState({ chartFromAprilData: chartFromAprilData })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Triangulations(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.TriangulationNMonths(this.props.match.params.accountId, ''))
    this.setState({ accountYearList: null }, () => {
      this.getTriangulations(context)
      this.getTriangulationFromApril(context)
    }
    )
  }
}

export default withRouter(TriangulationChartPageSF)
